<template>
    
    <div class="list-item list-item--article"
        :class="css"
        ref="article">
        <div class="cell cell--cb">
            <input type="checkbox" :disabled="!variation.isPurchasable || !variation.article.isActive" :value="variation" v-model="model" />
        </div>
        <div class="cell cell--ref">
            {{ variation.article.reference }}
        </div>
        <div class="cell cell--main">            
            <ArticleTitle :article="variation.article" />
        </div>
        <div class="cell">{{ variation.uvCodeLibelle }}<span v-if="variation.uvCoef > 1" style="white-space: pre">&nbsp;x{{ variation.uvCoef }}</span></div>
        <div class="cell cell--price">
            <Price :amount="price" currency="EUR" />
        </div>
        <div class="cell cell--actions">
            <AddToFavorite v-if="!variation.isPurchasable || !variation.article.isActive"
                :article="variation.article"
                :variation="variation"
                :removeOnly="true" />
            <AddToCart
                :article="variation.article"
                :variation="variation" />
        </div>
    </div>

</template>

<script>

import AddToCart from '@/components/addToCart/AddToCart.vue'
import AddToFavorite from '@/components/addToFavorite/AddToFavorite.vue'
import ArticleTitle from '@/components/articleTitle/ArticleTitle.vue'
import Price from '@/components/price/Price.vue'

export default {

    props: {

        variation: {
            type: Object,
            required: true
        },

        value: Array
    },
    
    computed: {

        css: function () {
            return ''
        },       

        price: function() {
            
            if ( this.variation.price ) {
                return ( this.variation.price + this.variation.tgap )
            }

            return null
        },

        model: {

            get() {
                return this.value;
            },

            set(value) {
                this.$emit("input", value);
            }
        }
    },

    components: {
        AddToCart,
        AddToFavorite,
        ArticleTitle,
        Price,
    }
}
</script>

<style scoped>

.list-item.list-item--article .cell.cell--actions {
    min-width: 10rem;
}

</style>